import React, { useEffect, useState } from "react";

import {
    Box,
    Typography,
} from '@mui/material';

import BaseCheckbox from "./BaseCheckbox";


function SettingsCheckBox(props) {

    const {
        description='',
        disabled=false,
        label='',
        onChange = () => {},
        options=[],
        original='',
        value='',
    } = props

    const [focused, setFocused] = useState(false);
    const [uncommittedChanges, setUncommittedChanges] = useState(false);

    useEffect(() => {
        original === value ? setUncommittedChanges(false) : setUncommittedChanges(true);
    }, [value, original])

    function handleChange(newValue) {
        onChange(newValue);
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            m={1}
            position='relative'
        >
            {
                uncommittedChanges && 
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    mx={-1}
                    my={0.5}
                >
                    <Box
                        width={5}
                        height={5}
                        borderRadius={5}
                        backgroundColor={'rgba(255, 193, 7, 1)'} // warning color (amber)
                    />
                </Box>
            }
            <Typography
                variant="subtitle2"
                fontWeight={900}
                fontSize="12px"
                sx={{
                    color: disabled ? 'rgba(175, 175, 175, 1)'
                        : focused ? 'rgba(178, 235, 177, 1)'
                        : 'rgba(255, 255, 255, 1)'
                }}
            >
                {label}{options.length > 0
                    ?
                        <span style={{ fontWeight: 300 }}>{`: ${options.find(option => option.value === value)?.name}`}</span>
                    :
                        ''
                }
            </Typography>
            <Box
                display='flex'
            >
                <Box>
                    <BaseCheckbox
                        sx={{
                            padding: 0,
                            marginRight: 1
                        }}
                        disabled={disabled}
                        checked={value}
                        onChange={(event) => handleChange(event.target.checked)}
                        onFocus={() => {
                            setFocused(true);
                        }}
                        onBlur={(e) => {
                            setFocused(false);
                        }}
                        onKeyDown={(e) => {
                            if (['Enter', 'NumpadEnter', 'Tab'].includes(e.key)) {
                                handleChange(!value)
                                e.target.blur();
                            }
                            if (e.key === 'Escape') {
                                e.target.blur()
                            }
                        }}
                    />
                </Box>
                <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    fontSize="11px"
                    color="rgb(150, 150, 150)"
                >
                    {description}
                </Typography>

            </Box>
        </Box>
    );
}

export default SettingsCheckBox;